import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faXTwitter, faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons';

const SocialMediaIcons = () => {
  return (
    <div className="flex sm:justify-center sm:mt-0">
      <a href="https://www.facebook.com/" className="text-gray-300 hover:text-white">
        <FontAwesomeIcon icon={faFacebook} className="text-2xl" />
        <span className="sr-only">Facebook page</span>
      </a>
      <a href="https://x.com/PocketLPO" className="text-gray-300 hover:text-white ms-5">
        <FontAwesomeIcon icon={faXTwitter} className="text-2xl" />
        <span className="sr-only">Twitter page</span>
      </a>
      <a href=" https://www.linkedin.com/company/pocketlpo/" className="text-gray-300 hover:text-white ms-5">
        <FontAwesomeIcon icon={faLinkedin} className="text-2xl" />
        <span className="sr-only">LinkedIn account</span>
      </a>
      <a href="https://www.instagram.com/" className="text-gray-300 hover:text-white ms-5">
        <FontAwesomeIcon icon={faInstagram} className="text-2xl" />
        <span className="sr-only">Instagram profile</span>
      </a>
    </div>
  );
};

export default SocialMediaIcons;
